export default "__VITE_ASSET__DEA9xMOY__"